export function isDemoModeEnabled() {
  if (import.meta.env.VITE_DEMO_MODE === "1") return true;
  if (typeof window === "undefined") return false;
  return sessionStorage.getItem("lexipro_demo_env") === "1";
}
